import { useTranslations } from "next-intl";
import { useCartStore } from "../cart-provider";
import { ClearCartForm } from "../clear-cart";

export const CartHeaderButtons = () => {
  const t = useTranslations();
  const cartStore = useCartStore((state) => state);
  const dietCount = cartStore.items.length;

  return (
    <div className="flex h-5 items-center justify-between">
      {dietCount !== 0 && (
        <span>{t("cart.numberOfDietsInCart", { count: dietCount })}</span>
      )}
      {dietCount !== 0 && <ClearCartForm />}
    </div>
  );
};
